import styled, { css } from 'styled-components'

import SubmitOrCancel from 'live/components/forms/ui/submit-or-cancel'

export const Row = styled.div<{ collapsed: boolean; inactive: boolean; mustSave: boolean }>`
    background-color: #fff;
    margin-bottom: ${({ collapsed }) => (collapsed ? '12px' : '0')};
    border-radius: 4px 4px ${({ collapsed }) => (collapsed ? '4px 4px' : '0 0')};
    border: solid 1px ${({ mustSave, inactive }) => (mustSave ? '#37a3ef' : '#dddee1') + (inactive ? '99' : '')};
    box-shadow: none;
    padding: 14px;
    user-select: none;

    ${({ mustSave, collapsed }) =>
        !collapsed &&
        mustSave &&
        css`
            border-bottom: #dddee1;
        `}
`

export const AlarmDescription = styled.div<{ clipText?: boolean; hidden?: boolean }>`
    display: inline-block;
    font-size: 14px;
    font-family: ${({ theme }) => theme['font-semibold']};
    color: ${({ theme }) => theme['text-color'] || '#364159'};
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    ${({ hidden }) =>
        hidden &&
        css`
            visibility: hidden;
        `}

    ${({ clipText }) =>
        clipText &&
        css`
            width: 70%;
        `}
`

export const ConditionPillsContainer = styled.div<{ hidden?: boolean }>`
    display: flex;

    ${({ hidden }) =>
        hidden &&
        css`
            visibility: hidden;
        `}
`

export const ConditionPill = styled.div<{ withUom: boolean }>`
    display: flex;
    align-items: center;
    margin-left: 5px;
    height: 16px;
    padding: 0 8px;
    border-radius: 40px;
    background-color: #868695;
    font-size: 9px;
    font-family: ${({ theme }) => theme['font-semibold']};
    color: white;
    white-space: nowrap;

    .alarms--card-description--pill--condition {
        text-transform: uppercase;
        margin-right: ${({ withUom }) => (withUom ? '2px' : '0')};
    }
`

export const MustSave = styled.span`
    margin-left: 5px;
    font-size: 12px;
    color: #868695;
    font-style: italic;
`

export const Grid = styled.div<{ includesRuleType: boolean; sideview: boolean }>`
    display: grid;
    grid-gap: 8px;

    ${({ includesRuleType, sideview }) =>
        sideview
            ? includesRuleType
                ? css`
                      grid-template-columns: repeat(3, 1fr);
                      grid-template-areas:
                          'description description description'
                          'severity severity rule-type';
                  `
                : css`
                      grid-template-columns: repeat(3, 1fr);
                      grid-template-areas: 'description description severity';
                  `
            : includesRuleType
            ? css`
                  grid-template-columns: 1fr;
                  grid-template-areas:
                      'description'
                      'severity'
                      'rule-type';

                  @media (min-width: 750px) {
                      grid-template-columns: repeat(3, 1fr);
                      grid-template-areas:
                          'description description description'
                          'severity severity rule-type';
                  }

                  @media (min-width: 1250px) {
                      grid-template-columns: 4fr 2fr 1fr;
                      grid-template-areas: 'description severity rule-type';
                  }
              `
            : css`
                  grid-template-columns: 1fr;
                  grid-template-areas:
                      'description'
                      'severity';

                  @media (min-width: 750px) {
                      grid-template-columns: repeat(3, 1fr);
                      grid-template-areas: 'description description severity';
                  }

                  @media (min-width: 1250px) {
                      grid-template-columns: 2fr 1fr;
                      grid-template-areas: 'description severity';
                  }
              `}
`

export const AlarmSeverity = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 16px;
    font-size: 13px;
    font-family: ${({ theme }) => theme['font-semibold']};
    color: #868695;

    > div {
        display: flex;
        align-items: center;

        > .fas {
            font-size: 11px;
            margin-right: 8px;
            margin-bottom: 2px;
        }

        > div {
            text-transform: capitalize;
        }
    }
`

export const SaveOrCancel = styled(SubmitOrCancel)`
    .live-global-alert {
        /* hide it because it wouldn't be shown correctly and the button already has feedback */
        display: none;
    }
`
